// Cart Upsell Form Handler - Uses Alpine.js cart store
document.addEventListener('alpine:init', () => {
  // Wait for Alpine to be ready
  setTimeout(() => {
    initCartUpsellForms();
  }, 100);
});

// Also init if Alpine is already loaded
if (window.Alpine) {
  setTimeout(() => {
    initCartUpsellForms();
  }, 100);
}

function initCartUpsellForms() {
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.cart-upsell-form button[type="submit"]');
    if (!button) return;

    e.preventDefault();

    const form = button.closest('form');
    if (!form || !form.classList.contains('cart-upsell-form')) return;

    // Always use custom handler for cart upsell forms (to send attributes)
    await handleFormSubmitFallback(form, button);
  });
}

async function handleFormSubmitFallback(form, button) {
  const originalText = button.textContent;

  try {
    button.disabled = true;
    button.textContent = 'Adding...';

    // Get data from form attributes
    const variantId = form.dataset.variantId;
    const discountType = form.dataset.discountType;
    const discountValue = form.dataset.discountValue;

    // Add product to cart
    const addPayload = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(addPayload)
    });

    if (!addResponse.ok) {
      throw new Error('Failed to add to cart');
    }

    // If product has discount, update cart attributes
    if (discountType && discountValue) {
      await updateCartUpsellDiscounts(variantId, discountType, discountValue);
    }

    // Dispatch cart refresh event to update the cart drawer
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    button.textContent = 'Added!';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);

  } catch (error) {
    console.error('Error adding to cart:', error);
    button.textContent = 'Error';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
  }
}

// Update cart attributes with upsell discount info
async function updateCartUpsellDiscounts(variantId, discountType, discountValue) {
  try {
    // Get current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Parse existing upsell_discounts attribute
    const currentDiscounts = cart.attributes?.upsell_discounts || '';

    // Build discount map
    const discountMap = {};

    if (currentDiscounts) {
      const entries = currentDiscounts.split(',');
      entries.forEach(entry => {
        const parts = entry.trim().split(':');
        if (parts.length === 3) {
          const [vid, type, value] = parts;
          discountMap[vid] = { type, value };
        }
      });
    }

    // Add new discount
    discountMap[variantId] = {
      type: discountType,
      value: discountValue
    };

    // Build new string
    // Format: "variantId:type:value,variantId:type:value"
    const newDiscountsStr = Object.entries(discountMap)
      .map(([vid, data]) => `${vid}:${data.type}:${data.value}`)
      .join(',');

    // Update cart attributes
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          upsell_discounts: newDiscountsStr
        }
      })
    });

    if (!updateResponse.ok) {
      throw new Error('Failed to update cart attributes');
    }

  } catch (error) {
    console.error('Error updating cart upsell discounts:', error);
  }
}
